//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
export default {
  name: 'RecommendPage',
  extends: vComponent,
  props: {
    items: {
      type: Array,
      default: () => []
    },
    payment: {
      type: Array,
      default: () => []
    },
    memo: {
      type: String,
      default: ''
    },
    invoice: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      columns: [ // 欄位宣告
        { name: 'PC_NAME', label: '商品名稱', field: 'productName' },
        { name: 'PRICE', label: '單價', field: 'price' },
        { name: 'CNT', label: '數量', field: 'count' },
        { name: 'TOTAL', label: '金額', field: 'total' }
      ],
      subPages: [
        { id: 'infoModal', label: '資訊', icon: 'info' },
        { id: 'stockModal', label: '庫存', icon: 'storage' },
        { id: 'rankModal', label: '排行', icon: 'equalizer' },
        { id: 'relatedModal', label: '關聯', icon: 'dashboard' }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 10 // 0 means all rows
      }
    }
  },
  computed: {
    ...mapGetters([
      'theme'
    ]),
    subItems () {
      // 將item下的addition也當作一個subitem顯示
      const result = []
      this.items.forEach(item => {
        if (item.additions) {
          if (this.$q.screen.lt.sm) {
            // 小尺寸grid顯示時的資料 將口味加料訊息放到名稱上
            let tmp = []
            for (const prop in item.additions) {
              tmp.push(item.additions[prop].name)
            }
            item.productName += `(${tmp.join(',')})`
            result.push(item)
          } else {
            result.push(item)
            for (const prop in item.additions) {
              const additionItem = {
                productName: item.additions[prop].name,
                price: item.additions[prop].price,
                isAddition: true
              }
              result.push(additionItem)
            }
          }
        } else {
          result.push(item)
        }
      })
      result.forEach(item => {
        // if (item.price && typeof item.price === 'number') item.price = Math.round(item.price)
        if (item.count && item.price) item.total = Math.round(item.count * item.price)
      })
      // console.log(`sub Items==`)
      // console.log(result)
      return result
    },
    paytypeItems () {
      return this.items.filter(item => {
        return item.type === 'paytype'
      })
    }
  },
  created () {
  },
  methods: {
    clickSubBtn (row, type) {
      this.emit(`DetailTable.ShowModal`, type, row.PLU_CODE)
    },
    clickTest (props) {
      console.log(props)
    }
  }
}
